module.exports = __webpack_public_path__ + "static/Allocation-4195d5c9bcadeda2b4e440147b21fb6f.svg";